import React from 'react';
import { Skeleton, Card } from 'antd';
import styled, { keyframes } from 'styled-components';

// 骨架屏动画
const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const ShimmerDiv = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 400% 100%;
  animation: ${shimmer} 1.2s ease-in-out infinite;
  height: 160px;
  background-color: #f0f0f0;
  border-radius: 8px 8px 0 0;
`;

const SkeletonWrapper = styled.div`
  .skeleton-shimmer {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 400% 100%;
    animation: ${shimmer} 1.2s ease-in-out infinite;
  }
`;

const SkeletonGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: flex-start;
`;

const SkeletonCard = styled(Card)`
  width: ${props => props.$gridMode ? '100%' : '220px'};
  min-width: ${props => props.$gridMode ? '0' : '90px'};
  flex-shrink: 0;
  
  ${props => !props.$gridMode && `
    @media (max-width: 1400px) {
      width: 220px;
    }
    
    @media (max-width: 1200px) {
      width: 220px;
    }
    
    @media (max-width: 768px) {
      width: 220px;
    }
    
    @media (max-width: 576px) {
      width: calc(50% - 8px);
      min-width: 120px;
    }
    
    @media (max-width: 480px) {
      width: calc(50% - 8px);
      min-width: 100px;
    }
  `}
`;

// 卡片骨架屏
export const CardSkeleton = ({ count = 3, gridMode = false }) => {
  const cards = Array.from({ length: count }).map((_, index) => (
    <SkeletonCard
      key={index}
      $gridMode={gridMode}
      cover={<ShimmerDiv />}
    >
      <Skeleton active paragraph={{ rows: 2 }} />
    </SkeletonCard>
  ));

  if (gridMode) {
    return <>{cards}</>;
  }

  return (
    <SkeletonGrid>
      {cards}
    </SkeletonGrid>
  );
};

// 图片骨架屏
export const ImageSkeleton = ({ width = '100%', height = 160, style = {} }) => (
  <SkeletonWrapper>
    <div 
      className="skeleton-shimmer"
      style={{ 
        width,
        height,
        backgroundColor: '#f0f0f0',
        borderRadius: 8,
        ...style
      }} 
    />
  </SkeletonWrapper>
);

// 品牌卡片骨架屏
export const BrandSkeleton = ({ count = 8 }) => (
  <SkeletonWrapper>
    <div style={{ 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', 
      gap: 16 
    }}>
      {Array.from({ length: count }).map((_, index) => (
        <div 
          key={index}
          style={{ 
            padding: 16, 
            border: '1px solid #f0f0f0', 
            borderRadius: 8,
            textAlign: 'center'
          }}
        >
          <div 
            className="skeleton-shimmer"
            style={{ 
              width: 80, 
              height: 60, 
              margin: '0 auto 8px',
              backgroundColor: '#f0f0f0',
              borderRadius: 4
            }} 
          />
          <Skeleton.Input style={{ width: 60 }} size="small" active />
        </div>
      ))}
    </div>
  </SkeletonWrapper>
);

export default { CardSkeleton, ImageSkeleton, BrandSkeleton };